import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {
  Grid,
  Button,
  Typography,
} from '@material-ui/core';

import Table from '../../components/Table';
import Filters from '../../components/Admins/Filters';
import Row from '../../components/Admins/Row';
import ErrorDialog from '../../components/ErrorDialog';

class Admins extends PureComponent {
  constructor() {
    super();

    this.state = {
      rows: [
        { id: 'id', numeric: false, disablePadding: false, label: '#' },
        { id: 'name', numeric: false, disablePadding: true, label: 'Nombre' },
        { id: 'username', numeric: false, disablePadding: true, label: 'Nombre de usuario' },
        { id: 'email', numeric: false, disablePadding: true, label: 'Email' },
        { id: 'actions', numeric: false, disablePadding: false, label: 'Acciones' },
      ],
    };

    this.handleAdminsPagination = this.handleAdminsPagination.bind(this);
  }

  componentDidMount() {
    this.handleAdminsPagination();
  }

  componentDidUpdate(prevProps) {
    const { location: { search } } = this.props;
    const currentPage = this.pageNumber(search);
    const previousPage = this.pageNumber(prevProps.location.search);
    if (currentPage !== previousPage) {
      this.handleAdminsPagination();
    }
  }

  handleAdminsPagination() {
    const { getAdmins, location: { search } } = this.props;
    getAdmins(this.pageNumber(search));
  }

  pageNumber(search) {
    const { page } = queryString.parse(search);
    return page;
  }

  handleNewClick() {
    this.props.history.push('/admins/new');
  }

  render() {
    const {
      history,
      error,
      isFetching,
      admins,
      deleteAdmin,
      search,
      total,
      pages,
      location,
      clearError,
    } = this.props;
    const { rows } = this.state;

    return (
      <Grid container alignItems="center">
        <Grid item xs>
          <Typography variant="display1"> Administradores </Typography>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => this.handleNewClick()}>
            Nuevo Administrador
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Filters search={search} />
        </Grid>
        <Grid item xs={12}>
          <Table
            isFetching={isFetching}
            rows={rows}
            data={admins}
            total={total}
            pages={pages}
            history={history}
            paginated
            page={parseInt(this.pageNumber(location.search) - 1, 10)}
            renderRows={({ item }) =>
              (<Row
                key={item.id}
                admin={item}
                history={history}
                onDelete={deleteAdmin}
              />)
            }
          />
        </Grid>
        { (error.error || error.message) &&
          <ErrorDialog error={error.error || error.message} action={clearError} />
        }
      </Grid>
    );
  }
}

export default Admins;

Admins.propTypes = {
  admins: PropTypes.array.isRequired,
  error: PropTypes.object.isRequired,
  getAdmins: PropTypes.func.isRequired,
  deleteAdmin: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  clearError: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Admins/index.js